import { render, staticRenderFns } from "./CourseSalesHistoryPage.vue?vue&type=template&id=4c82eb68&scoped=true"
import script from "./CourseSalesHistoryPage.vue?vue&type=script&lang=js"
export * from "./CourseSalesHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./CourseSalesHistoryPage.vue?vue&type=style&index=0&id=4c82eb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82eb68",
  null
  
)

export default component.exports